import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Locale } from "@/Common/Models/Localization/Locale";
import { OntarioPatientEnrollmentModel } from "@/Common/Models/Patient/PatientEnrollment/Ontario/OntarioPatientEnrollmentModel";
import { Person } from "@/Common/Models/Person/Person";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";

interface IOntarioPatientEnrollmentItemProps {
    enrollment: OntarioPatientEnrollmentModel;
    onEdit: () => void;
    getPhysician: (contactFacetId: string) => Person;
    onDelete?: () => void;
}

class OntarioPatientEnrollmentItem extends BaseReactComponent<IOntarioPatientEnrollmentItemProps> {
    public componentWillMount(): void {
        this.setAcceptableLocales([Locale.en, Locale.fr]);
    }

    public render(): JSX.Element {
        const enrollment = this.props.enrollment;

        return (
            <div className="patient-enrollment-item">
                {this.renderEditDeleteButtons()}
                <div className="table-wrapper">
                    <table className="enrollment-table">
                        <tbody>
                            {this.getRowsForEnrollment()
                                .map((row, idx) => this.renderTableRow(row.label, row.value, `${enrollment.Id}_${idx}`))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    private renderEditDeleteButtons(): JSX.Element {
        return (
            <div className="text-right push-right-5">
                <a className="padding-xs-right" onClick={() => this.props.onEdit()}>{this.getString("EDITLabel")}</a>
                {this.props.onDelete && (
                    <>
                        <span>|</span>
                        <a className="padding-xs-left margin-sm-right" onClick={() => this.props.onDelete()}>{this.getString("DeleteLabel")}</a>
                    </>
                )}
            </div>
        );
    }

    private renderTableRow(label: string, value: string, key: string): JSX.Element {
        return (
            <tr key={key}>
                <td>
                    <span>{label}</span>
                </td>
                <td className="table-value">
                    <strong>{value}</strong>
                </td>
            </tr>
        );
    }

    private getRowsForEnrollment(): { label: string, value: string }[] {
        let rows = [
            {
                label: this.getString("PhysicianNameLabel"),
                value: this.props.getPhysician(this.props.enrollment.EnrolledPhysicianId)?.NameWithPrefix
            },
            {
                label: this.getString("EnrolmentStartDateLabel"),
                value: LuxonDateTimeParser.parse(this.props.enrollment.EnrollmentStartDate)?.toFormat("yyyy-MM-dd")
            }
        ];

        if (!this.props.enrollment.isCurrentEnrollment()) {
            rows = [
                ...rows,
                {
                    label: this.getString("EnrolmentEndDateLabel"),
                    value: LuxonDateTimeParser.parse(this.props.enrollment.EnrollmentEndDate)?.toFormat("yyyy-MM-dd")
                },
                {
                    label: this.getString("TerminationReasonLabel"),
                    value: OntarioPatientEnrollmentModel.GetTerminationCodeString(this.props.enrollment.TerminationReasonCode)
                }
            ];
        }

        return rows;
    }
}

export { OntarioPatientEnrollmentItem };
